"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/objectWithoutProperties"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _react = _interopRequireDefault(require("react"));

var _StyledSvg = _styledComponents["default"].svg.withConfig({
  displayName: "Target___StyledSvg",
  componentId: "sc-3vkyxi-0"
})(["color:", ";width:", ";height:", ";vertical-align:text-top;"], function (p) {
  return p._css;
}, function (p) {
  return p._css2;
}, function (p) {
  return p._css3;
});

function Target(_ref) {
  var _ref$title = _ref.title,
      title = _ref$title === void 0 ? null : _ref$title,
      props = (0, _objectWithoutProperties2["default"])(_ref, ["title"]);
  return _react["default"].createElement(_StyledSvg, (0, _extends2["default"])({
    width: "1em",
    height: "1em",
    viewBox: "0 0 480 480",
    focusable: false,
    "data-wbi-icon": true
  }, props, {
    _css: props.color,
    _css2: props.size,
    _css3: props.size
  }), title ? _react["default"].createElement("title", null, title) : null, _react["default"].createElement("path", {
    fill: "currentColor",
    d: "M213.246 285.832c-11.306 0-20.472-9.255-20.472-20.671 0-11.417 9.166-20.672 20.472-20.672 11.306 0 20.472 9.255 20.472 20.672 0 11.416-9.166 20.67-20.472 20.67zM446.911 58.448l-86.125 86.964 57.178 57.735H274.66v-144.7l57.178 57.736 86.125-86.964 28.947 29.229zM151.831 265.16c0 34.21 27.555 62.013 61.415 62.013s61.415-27.823 61.415-62.013h40.944c0 56.99-45.918 103.356-102.359 103.356-56.44 0-102.359-46.366-102.359-103.356 0-56.991 45.918-103.357 102.36-103.357v41.343c-33.861 0-61.416 27.823-61.416 62.014zm61.415 144.698c79 0 143.303-64.887 143.303-144.698h40.943c0 102.591-82.644 186.041-184.246 186.041C111.645 451.202 29 367.752 29 265.161c0-102.592 82.645-186.042 184.246-186.042v41.343c-79 0-143.302 64.907-143.302 144.699 0 79.79 64.301 144.698 143.302 144.698z"
  }));
}

var _default = Target;
exports["default"] = _default;